import loadable from "@loadable/component";
import classnames from "classnames";
import i18next from "i18next";
import React from "react";
import { FauxButton } from "./";
import { ButtonKind } from "./Button.component";
import "./ListenLive.style.scss";

const UnionIcon = loadable(() => import("../components/icons/UnionIcon.component"));

interface ListenLiveProps {
    url: string;
    text?: string;
    showIcon?: boolean;
    size?: "small" | "";
}

export const ListenLive = ({ text = i18next.t("listen_live"), showIcon = true, size = "", url }: ListenLiveProps) => {
    if (url?.length) {
        const liveClass = classnames("live-button", {
            [`size-${size}`]: size,
        });
        return (
            <FauxButton kind={ButtonKind.PRIMARY} to={url} target="_blank" className={liveClass}>
                {text}
                {showIcon ? <UnionIcon /> : null}
            </FauxButton>
        );
    }
    return null;
};
